import React from "react";
import { CiExport } from "react-icons/ci";
import { FiShield } from "react-icons/fi";
import { LuTimer, LuUserPlus } from "react-icons/lu";
import { useNavigate } from "react-router-dom";

export default function QuickActions() {
  const navigate=useNavigate();
  return (
    <div className="actions-col" style={{
      background: "#fff", borderRadius: "12px",
      boxShadow: "0 2px 16px #eee", padding: "20px 24px", marginBottom: "0"
    }}>
      <h5 className="h5" style={{marginBottom:10}}>Quick Actions</h5>
      <ul style={{listStyle:"none",padding:0,margin:0}}>
        <li><button onClick={()=>navigate("/StaffAdd")} className="gradient-button w-100 my-2" style={{display:'flex',justifyContent:'center',alignItems:'center'}}><LuUserPlus style={{marginRight:5}}/>Add New Staff</button></li>
        <li><button className="gradient-button w-100 my-2" style={{display:'flex',justifyContent:'center',alignItems:'center'}}><FiShield style={{marginRight:5}}/>Manage Roles</button></li>
        <li><button onClick={()=>navigate("/StaffAttendence")} className="gradient-button w-100 my-2" style={{display:'flex',justifyContent:'center',alignItems:'center'}}><LuTimer style={{marginRight:5}}/>Attendence</button></li>
        <li><button className="gradient-button w-100 my-2" style={{display:'flex',justifyContent:'center',alignItems:'center'}}><CiExport style={{marginRight:5}}/>Export Staff List</button></li>
      </ul>
    </div>
  );
}

const btnStyle = {
  width:"100%",
  margin:"7px 0",
  padding:"9px 0",
  background:"#f8f9fb",
  border:"1px solid #ececec",
  borderRadius:"7px",
  textAlign:"left",
  fontSize:"1em",
  cursor:"pointer"
};
